import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
// import { createLogger } from 'redux-logger';
import promiseMiddleware from 'redux-promise-middleware';
import thunkMiddleware from 'redux-thunk';

import customMiddleware from '../middleware';
import Reducers from '../modules';
/*
I commented out the loggerMiddleware as it makes it very difficult to read other
logs while providing little value of its own. This information can be seen in the redux store
using a chrome extension or you can uncomment out this loger.
 */
const defaultState = {};
// const loggerMiddleware = createLogger();
const RootReducer = combineReducers({ ...Reducers });
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose; // eslint-disable-line no-underscore-dangle

const store = createStore(
  RootReducer,
  defaultState,
  composeEnhancers(
    applyMiddleware(
      ...customMiddleware,
      // loggerMiddleware,
      thunkMiddleware,
      promiseMiddleware
    )
  )
);

export default store;
